

import Vue from 'vue'
import Component from "vue-class-component";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import {ICourier} from "@/model/Courier/courierInterfaces";
import {countries} from "@/locale/countries";
import CreateButton from "@/components/shared/CreateButton.vue";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
import CourierEditDialog from "@/components/courier/CourierEditDialog.vue";

const courierModule = namespace("courierModule");

@Component({
  components: {
    CourierEditDialog,
    CreateButton,
    SimpleConfirmationDialog,
  }
})
export default class CourierList extends Vue {

  @courierModule.Getter('couriers')
  protected couriers!: ICourier[];

  protected loading: boolean = true;
  protected editShowing: boolean = false;
  protected editingCourier: ICourier|null = null;
  protected deleteShowing: boolean = false;
  protected deletingCourier: ICourier|null = null;
  protected deleting: boolean = false;
  protected togglingId: number|null = null;
  private subscribes: IOnOffHandlers = {};

  protected get headers() {
    return [
      {text: this.$t('settings.couriers.fields.name'), value: 'name'},
      {text: this.$t('settings.couriers.fields.code'), value: 'code'},
      {text: this.$t('settings.couriers.fields.countries'), value: 'countries', sortable: false},
      {text: this.$t('common.active'), value: 'active', width: 100},
      {text: '', value: 'actions', sortable: false, align: 'end', width: 120},
    ];
  }

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.loadData,
      'backend.call.OK.couriersLoaded': this.onLoaded,
      'backend.call.KO.couriersLoaded': this.onLoaded,
      'backend.call.OK.courierSaved': this.onToggled,
      'backend.call.KO.courierSaved': this.onToggleKO,
      'backend.call.OK.courierDeleted': this.onDeletedOK,
      'backend.call.KO.courierDeleted': this.onDeletedKO,
    });
    this.loadData();
  }
  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  public loadData() {
    this.loading = true;
    this.$store.dispatch('courierModule/fetchCouriers');
  }

  protected countryName(countryId: number): string {
    const country = countries.find(each => each.value === countryId);
    return country ? country.text : String(countryId);
  }

  protected onCreate() {
    this.editingCourier = null;
    this.editShowing = true;
  }
  protected onEdit(courier: ICourier) {
    this.editingCourier = courier;
    this.editShowing = true;
  }

  protected onToggleActive(courier: ICourier, active: boolean) {
    this.togglingId = courier.id;
    this.$store.dispatch('courierModule/updateCourier', {courierId: courier.id, courier: {active: !!active}});
  }

  protected onDelete(courier: ICourier) {
    this.deletingCourier = courier;
    this.deleteShowing = true;
  }
  protected onDeleteConfirmed() {
    this.deleting = true;
    this.$store.dispatch('courierModule/deleteCourier', this.deletingCourier!.id);
  }

  private onLoaded() {
    this.loading = false;
  }
  private onToggled() {
    this.togglingId = null;
  }
  private onToggleKO() {
    if (this.togglingId !== null) {
      this.togglingId = null;
      this.loadData();
    }
  }
  private onDeletedOK() {
    this.deleting = false;
    this.deleteShowing = false;
    this.$uiBus.emit('success', this.$t('settings.couriers.toastDeleted'));
    this.loadData();
  }
  private onDeletedKO() {
    this.deleting = false;
  }
}

